export default __webpack_public_path__ + "static/media/partner-dropp-2.464abd14.jpg";